import React, { useState, useEffect, useContext } from 'react';
import ReactPlayer from 'react-player';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHeadphones,
  faMicrophoneLines,
  faMusic,
  faCompactDisc,
  faFileSignature,
  faMicrophone,
  faBuilding,
  faPerson,
  faSearch,
  faCalendar,
  faLanguage,
  faPeopleCarry,
} from '@fortawesome/free-solid-svg-icons';

import { faFileLines, faImage } from '@fortawesome/free-regular-svg-icons';
import 'react-sweet-progress/lib/style.css';
import Loader from '../../Loader';
import $ from 'jquery';
import { ApiConsumer, Backend } from 'api/ApiConsumer';
import { API_ROUTES } from 'routes/api';
import { useHistory } from 'react-router-dom';
import { Disclosure } from '@headlessui/react';
import {
  faDeezer,
  faSpotify,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { useAuthentication } from 'hooks/AuthenticationHook';
import { NotificationContext } from 'context/NotificationContext';
import _get from 'lodash/get';
import { LibrarySlideOverContext } from 'context/LibrarySlideOverContext';

const _validFileExtensionsArtwork = ['.jpg', '.jpeg', '.png', '.gif'];

const channels = [
  { id: 0, value: '', disabled: true, selected: true, name: 'Music Type' },
  {
    id: 1,
    value: 'KTKW',
    disabled: false,
    selected: false,
    name: 'Kwaito Kwasa',
  },
  {
    id: 2,
    value: 'KS-KS',
    disabled: false,
    selected: false,
    name: 'Kwasa-Kwasa',
  },
  {
    id: 3,
    value: 'TRD',
    disabled: false,
    selected: false,
    name: 'Traditional',
  },
  {
    id: 4,
    value: 'JZ/A',
    disabled: false,
    selected: false,
    name: 'Jazz/Afro Pop',
  },
  {
    id: 5,
    value: 'CO/W',
    disabled: false,
    selected: false,
    name: 'Country/Western',
  },
  {
    id: 6,
    value: 'R&B/H',
    disabled: false,
    selected: false,
    name: 'R&D/Hip-Hop',
  },
  { id: 7, value: 'GPSL', disabled: false, selected: false, name: 'Gospel' },
  { id: 8, value: 'RGG', disabled: false, selected: false, name: 'Raggae' },
  { id: 9, value: 'HSE', disabled: false, selected: false, name: 'House' },
  { id: 10, value: 'RK', disabled: false, selected: false, name: 'Rock' },
  { id: 11, value: 'CRL', disabled: false, selected: false, name: 'Choral' },
  {
    id: 12,
    value: 'FMS',
    disabled: false,
    selected: false,
    name: 'Film Scores',
  },
  {
    id: 13,
    value: 'CSC',
    disabled: false,
    selected: false,
    name: 'Classic Music',
  },
  {
    id: 14,
    value: 'AD/JG',
    disabled: false,
    selected: false,
    name: 'Adverts/Jingles',
  },
  { id: 15, value: 'OTS', disabled: false, selected: false, name: 'Other' },
];

const genres = [
  { id: 1, value: 'amapiano', name: 'Amapiano' },
  { id: 2, value: 'gospel', name: 'Gospel' },
  { id: 3, value: 'house', name: 'House' },
  { id: 4, value: 'hip-hop', name: 'Hip Hop' },
  { id: 5, value: 'kwaito', name: 'Kwaito' },
  { id: 6, value: 'pop', name: 'Pop' },
];

const countries = [
  { id: 1, value: 'za', name: 'South African' },
  { id: 2, value: 'other', name: 'Other' },
]

const RELOAD_CURRENT_PAGE = 0;

const tget = (obj, path, defaultVal = '') => {
  const ret = _get(obj, path, defaultVal);
  return ret == null ? defaultVal : ret;
};

export default function EditLibraryItem({ track }) {
  const [title, setTitle] = useState(tget(track, 'title', ''));
  const [artist, setArtist] = useState(tget(track, 'artist', ''));

  const [artworkFile, setArtworkFile] = useState(tget(track, 'artwork', ''));
  const [album, setAlbum] = useState(tget(track, 'album', ''));
  const [isrc, setISRC] = useState(tget(track, 'isrc', ''));
  const [publisher, setPublisher] = useState(tget(track, 'publisher', ''));
  // TODO: add this back in after we have media types in the db
  //   const [musicType, setMusicType] = useState(tget(track, 'genre', ''));
  const [performingArtist, setPerformingArtist] = useState(
    tget(track, 'performer', ''),
  );
  //   const [recordingCompany, setRecordingCompany] = useState(
  //     tget(track, 'recordingCompany', ''),
  //   );
  const [label, setLabel] = useState(tget(track, 'title', ''));
  const [file_url, setFileUrl] = useState(tget(track, 'file', ''));

  // const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(tget(track, 'country_produced', ''));
  const [laguage, setLanguage] = useState(tget(track, 'language', ''));
  const [genre, setGenre] = useState(tget(track, 'genre', ''));
  const [author, setAuthor] = useState(tget(track, 'author', ''));
  const [arranger, setArranger] = useState(tget(track, 'arranger', ''));
  const [releaseYear, setReleaseYear] = useState(
    tget(track, 'release_year', ''),
  );
  const [youtube, setYouTube] = useState(tget(track, 'youtube_id', ''));
  const [deezer, setDeezer] = useState(tget(track, 'deezer_id', ''));
  const [spotify, setSpotify] = useState(tget(track, 'spotify_id', ''));

  const [isLoading, setIsLoading] = useState(false);

  let history = useHistory();
  let { user } = useAuthentication();

  let { setNotification } = useContext(NotificationContext);
  let { setLibraryItem } = useContext(LibrarySlideOverContext);

  function handleArtworkChange(e) {
    setArtworkFile(e.target.files[0].name);
  }

  const handleYouTube = (e) => {
    e.preventDefault();
    if (e.target.value !== null) {
      let regex =
        /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      let value = regex.exec(e.target.value)[3];
      setYouTube(value);
    }
  };

  const handleSpotify = (e) => {
    e.preventDefault();
    if (e.target.value !== null) {
      let regex =
        /(spoti.*fy.*)\/(track\/|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      let value = regex.exec(e.target.value)[3];
      setSpotify(value);
    }
  };

  const handleDeezer = (e) => {
    e.preventDefault();
    if (e.target.value !== null) {
      let regex =
        /(deez.*er.*)\/(us\/track\/|embed\/|v|shorts|)(.*?((?=[&#?])|$))/gm;
      let value = regex.exec(e.target.value)[3];
      setDeezer(value);
    }
  };

  function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    let form = $('#editItemForm').get(0);
    let data = new FormData(form);
    data.append('user_id', user()?.id);

    data.delete('user_id');

    // THIS IS A HACK THAT NEEDS A MORE PERMANENT SERVER-SIDE SOLUTION
    const fieldsThatAreRequired = ['album', 'label', 'publisher'];
    fieldsThatAreRequired.forEach((field) => {
      if (!data.get(field)) {
        data.set(field, '-');
      }
    });

    Backend.post(API_ROUTES.LIBRARY.EDIT_ITEM(track.id), data)
      .then(() => {
        setIsLoading(false);

        setLibraryItem({ open: false, track: {} });

        setNotification({
          show: true,
          title: 'Edit succeeded',
          message: `library item edited successfully`,
          type: 'success',
          time: 2000,
        });

        setTimeout(() => {
          history.go(RELOAD_CURRENT_PAGE);
        }, 3000);
      })
      .catch((err) => {
        setIsLoading(false);
        setNotification({
          show: true,
          title: 'Edit failed',
          message: `Edit failed to complete. Please try again later`,
          type: 'error',
        });
      });
  }

  // useEffect(() => {
  //   ApiConsumer.get(API_ROUTES.COUNTRIES.ALL)
  //     .then((res) => {
  //       setCountries(res.data);
  //     })
  //     .catch((err) => console.error(err))
  //     .finally(() => setIsLoading(false));
  // }, []);


  return (
    <div className="relative">
      
      <form
        id="editItemForm"
        className="min-h-full rounded px-5 py-5 mt-0 bg-white text-gray-800 "
        onSubmit={handleSubmit}
      >
        <p className='mt-4 w-full'>NB: Fields with *mark are mandatory </p>
        <div className="mt-6 grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-12">
          {ReactPlayer.canPlay(file_url) ? (
            <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
              <ReactPlayer url={file_url} controls width="100%" height="50px" />
            </div>
          ) : (
            <></>
          )}
          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faHeadphones}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-title"
              name="title"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Title*"
              required={true}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faMicrophoneLines}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-artist"
              name="artist"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Artist/Composer*"
              required={true}
              value={artist}
              onChange={(e) => setArtist(e.target.value)}
            />
          </div>

          {/* <div className="mt-1 flex rounsm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faMusic}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <select
              id="music-type"
              name="genre"
              onChange={(e) => setMusicType(e.target.value)}
              placeholder="Music Type"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            >
              {channels.map((channel) => {
                return (
                  <option
                    key={channel.id}
                    value={channel.value}
                    disabled={channel.disabled}
                    defaultValue={channel.selected}
                  >
                    {channel.name}
                  </option>
                );
              })}
            </select>
          </div> */}

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faCompactDisc}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-album"
              name="album"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Album"
              value={album}
              onChange={(e) => setAlbum(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faFileSignature}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-publisher"
              name="publisher"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Publisher"
              value={publisher}
              onChange={(e) => setPublisher(e.target.value)}
            />
          </div>

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faMicrophone}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-performing-artist"
              name="performer"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Performing Artist"
              value={performingArtist}
              onChange={(e) => setPerformingArtist(e.target.value)}
            />
          </div>

          {/* <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faCompactDisc}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-recording-company"
              name="label"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Recording Company"
              value={recordingCompany}
              onChange={(e) => setRecordingCompany(e.target.value)}
            />
          </div> */}

          <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faBuilding}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-label"
              name="label"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Composer/Label"
              value={label}
              onChange={(e) => setLabel(e.target.value)}
            />
          </div>
          {/* <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faPerson}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-label"
              name="author"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Author"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
            />
          </div> */}
          {/* <div className="mt-1 flex rounded-md shadow-sm sm:col-span-12">
            <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
              <FontAwesomeIcon
                icon={faPeopleCarry}
                className="h-4 w-4"
                aria-hidden="true"
              />
            </span>
            <input
              id="input-label"
              name="arranger"
              className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              type="text"
              placeholder="Arranger"
              value={arranger}
              onChange={(e) => setArranger(e.target.value)}
            />
          </div> */}

          <div className="mt-1 flex rounded-md sm:col-span-12 text-left">
            <div className="w-full">
              <div className="w-full mx-auto bg-white rounded-2xl grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-6">
                <Disclosure>
                  {({ open }) => (
                    <>
                      <Disclosure.Button
                        className={`uppercase sm:col-span-2 px-4 py-2 text-sm font-medium text-left text-blue-900 bg-blue-100 rounded-lg  ${open ? 'bg-blue-400' : 'hover:bg-blue-400'} focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75`}
                      >
                        <span>Other</span>
                      </Disclosure.Button>
                      <Disclosure.Panel className="py-2 text-sm text-gray-500 sm:col-span-6 grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-4 md:grid-cols-6">
                        <div className="relative mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faImage}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>

                          <label className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            {artworkFile === '' ? 'Upload Artwork' : artworkFile}
                          </label>
                          <div className="absolute inset-y-0 right-0 flex items-center">
                            <label className="flex flex-col items-center text-blue tracking-wide cursor-pointer bg-gray-300 text-gray-500 pr-3 h-full py-1 rounded-r-md">
                              <span className="text-base leading-normal">
                                <span>
                                  <FontAwesomeIcon
                                    icon={faSearch}
                                    className="h-4 w-4 px-3"
                                    aria-hidden="true"
                                  />
                                </span>
                                Browse
                              </span>
                              <input
                                type="file"
                                id="input-artwork"
                                onChange={handleArtworkChange}
                                name="artwork"
                                accept={_validFileExtensionsArtwork}
                                className="hidden"
                              />
                            </label>
                          </div>
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faCompactDisc}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-isrc"
                            name="isrc"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            placeholder="ISRC"
                            required={false}
                            value={isrc}
                            onChange={(e) => setISRC(e.target.value)}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faCalendar}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-release-year"
                            name="release_year"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="date"
                            required={false}
                            placeholder="Release Year"
                            value={releaseYear}
                            onChange={(e) => setReleaseYear(e.target.value)}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faMusic}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <select
                            id="genre"
                            name="genre"
                            onChange={(e) => setGenre(e.target.value)}
                            placeholder="Genre"
                            required={false}
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          >
                            <option value="" disabled selected={true}>
                              Genre
                            </option>
                            {genres.map((genre) => {
                              return (
                                <option key={genre.id} value={genre.value}>
                                  {genre.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faLanguage}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <select
                            id="language"
                            name="language"
                            onChange={(e) => setLanguage(e.target.value)}
                            placeholder="Language"
                            required={false}
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          >
                            <option value="" disabled selected={true}>
                              Language
                            </option>
                            <option value="english">English</option>
                            <option value="vernac">Vernac</option>
                          </select>
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faFileLines}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <select
                            id="country-produced"
                            name="country_produced"
                            onChange={(e) => setCountry(e.target.value)}
                            placeholder="Country Produced"
                            required={false}
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                          >
                            <option value="" disabled selected={true}>
                              Country Produced
                            </option>
                            {countries.map((country) => {
                              return (
                                <option key={country.id} value={country.id}>
                                  {country.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faYoutube}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-youtube"
                            name="youtube"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            required={false}
                            placeholder="YouTube page"
                            value={youtube}
                            onChange={handleYouTube}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faDeezer}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-deezer"
                            name="deezer"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            required={false}
                            placeholder="Deezer link"
                            value={deezer}
                            onChange={handleDeezer}
                          />
                        </div>

                        <div className="mt-1 flex rounded-md sm:col-span-12">
                          <span className="inline-flex items-center px-3 rounded-l-md bg-gray-300 text-gray-500 sm:text-sm">
                            <FontAwesomeIcon
                              icon={faSpotify}
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </span>
                          <input
                            id="input-spotify"
                            name="spotify"
                            className="flex-1 min-w-0 block w-full px-3 py-2 bg-gray-100 rounded-none rounded-r-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            type="text"
                            required={false}
                            placeholder="Sportify link"
                            value={spotify}
                            onChange={handleSpotify}
                          />
                        </div>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              </div>
            </div>
          </div>

          <div className="mt-1 flex rounded-md sm:col-span-12">
            <button
              type="submit"
              className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500s"
              onClick={handleSubmit}
            >
              {isLoading ? 'Saving Edits' : 'Save Edits'}
            </button>
          </div>
        </div>

        {isLoading ? <Loader /> : <></>}
      </form>
    </div>
  );
}
